/**
 *
 * @module deepObject/util
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('deepObject/util',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamDeepUtil = factory();
    }

}(this, function() {

    'use strict';

    var rebrackets = /\[(\d+)\]/g,
        reemptydot = /^\./;

    return {
        getProps: function( prop ) {
            return prop.replace(rebrackets, '.$1').replace(reemptydot, '').split('.');
        }
    };

}));

